export default __webpack_public_path__ + "media/images/seo/background-974ae5a46667034916e2228dd31fab14.png";